import { type RefObject, useLayoutEffect, useState } from "react";

export const MARQUEE_SPEED_PX_PER_SEC = 40;

export const useMarqueeDuration = (
  ref: RefObject<HTMLElement | null>,
  deps: unknown[] = []
) => {
  const [duration, setDuration] = useState(60);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const updateDuration = () => {
      setDuration(
        Math.max(element.scrollWidth / MARQUEE_SPEED_PX_PER_SEC, 20)
      );
    };

    updateDuration();

    const resizeObserver = new ResizeObserver(updateDuration);
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, deps);

  return duration;
};
